import { render, staticRenderFns } from "./base-input-number.vue?vue&type=template&id=2e92c68a"
import script from "./base-input-number.vue?vue&type=script&lang=js"
export * from "./base-input-number.vue?vue&type=script&lang=js"
import style0 from "./base-input-number.vue?vue&type=style&index=0&id=2e92c68a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports